export const SALES_LIST_REMOTE_TIMEOUT_MS = 12_000;

export async function withSalesListRemoteTimeout<T>(
  promise: Promise<T>,
  fallback: T,
  timeoutMs = SALES_LIST_REMOTE_TIMEOUT_MS,
): Promise<T> {
  let timer: ReturnType<typeof setTimeout> | undefined;
  try {
    return await Promise.race([
      promise,
      new Promise<T>((resolve) => {
        timer = setTimeout(() => resolve(fallback), timeoutMs);
      }),
    ]);
  } finally {
    if (timer) clearTimeout(timer);
  }
}
